


























import { Component } from "vue-property-decorator";
import MedPartBase from "./MedPartBase";

@Component
export default class OneOrThreeWeek extends MedPartBase {
  //週加算タイトル
  protected get titleWeekAddition(): string {
    let title = "週1回加算";
    if (
      this.event.indicate.longtime_beppyo_child_div == 1 ||
      this.event.indicate.longtime_severe_child_div == 1
    ) {
      title = "週3回加算";
    }
    return title;
  }

  //緊急訪問看護
  protected disableCheckMedicalUrgentFlg(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinkyu_houmon_kango_add == 0 ||
      this.baseDisableCheck()
    ) {
      result = true;
    }
    return result;
  }

  //訪問日時点で6歳以上か判定
  private isAgeAtLeast6OnVisitDate(): boolean {
    if (!this.birthday || this.event.start.length < 10) return false;
    const visitDate = new Date(this.event.start.substring(0, 10));
    const birthDate = new Date(this.birthday);
    let age = visitDate.getFullYear() - birthDate.getFullYear();
    const m = visitDate.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && visitDate.getDate() < birthDate.getDate())) {
      age--;
    }
    return age >= 6;
  }

  //乳幼児
  protected disableCheckInfantsFlg(): boolean {
    if (this.baseDisableCheck()) return true;
    if (this.isAgeAtLeast6OnVisitDate()) return true;
    return false;
  }

  //登録時に、disabledの項目は0にする
  public clearDisableItem() {
    //緊急訪問看護
    if (this.disableCheckMedicalUrgentFlg()) {
      this.receiptVisitRecord.medical_urgent_flg = 0;
    }
    //乳幼児
    if (this.disableCheckInfantsFlg()) {
      this.receiptVisitRecord.infants_flg = 0;
    }
  }
}
